import { Layout } from 'antd'

import { Outlet } from 'react-router-dom'

import Header from 'routes/Dashboard/ui/components/Header'

import { palette } from 'shared/config/styles/palette'

import Sider from './components/Sider'

const { Content } = Layout
export function DashboardWrapper() {
  return (
    <Layout style={{ minHeight: '100vh', background: palette.white }}>
      <Sider />
      <Layout style={{ background: palette.white }}>
        <Content className="flex flex-col relative">
          <Header />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
